// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"6e361b83","74":"217e2430","260":"86470e07","418":"c72f4d8e","484":"7e6519f4","530":"ea174d39","645":"2ab856a1","647":"e1bc3178","695":"9ac8f4e6","906":"b44225ae"}[chunkId] + ".chunk.js";
};